import { render, staticRenderFns } from "./mappingTableYear.vue?vue&type=template&id=60a46a00&scoped=true"
import script from "./mappingTableYear.vue?vue&type=script&lang=js"
export * from "./mappingTableYear.vue?vue&type=script&lang=js"
import style0 from "./mappingTableYear.vue?vue&type=style&index=0&id=60a46a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a46a00",
  null
  
)

export default component.exports